module.exports = "/images/Homepage-InteriorM.jpg";